<script setup lang="ts">
defineProps<{
  keywords: readonly string[]
}>()

defineEmits<{
  select: [keyword: string]
  clear: []
}>()
</script>

<template>
  <section class="search-history" aria-label="搜索历史">
    <div class="history-head">
      <span>搜索历史</span>
      <button class="history-clear" type="button" title="清空搜索历史" aria-label="清空搜索历史" @click="$emit('clear')">
        <i class="fa-regular fa-trash-can" aria-hidden="true" />
      </button>
    </div>
    <div class="history-keywords">
      <button
        v-for="keyword in keywords"
        :key="keyword"
        class="history-keyword"
        type="button"
        :title="keyword"
        @click="$emit('select', keyword)"
      >
        {{ keyword }}
      </button>
    </div>
  </section>
</template>

<style scoped>
.search-history {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.history-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  color: var(--text-soft);
  font-size: 13px;
}

.history-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  color: var(--text-soft);
  background: transparent;
  cursor: pointer;
}

.history-keywords {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
}

.history-keyword {
  min-width: 0;
  max-width: 100%;
  padding: 6px 10px;
  border: 0;
  border-radius: 999px;
  color: var(--text);
  background: var(--editor-bg);
  font: inherit;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: color 0.16s ease, background-color 0.16s ease;
}

.history-keyword:hover,
.history-keyword:focus-visible {
  color: var(--brand);
  background: var(--brand-soft);
}

.history-clear:hover {
  color: var(--brand);
}
</style>
